const routes = [
    //焦化苯
    {
        path: 'cokeBenzene',
        name: '焦化苯',
        component: () => import('@/views/cokeBenzene/index'),
    },
    {
        path: 'cokeBenzene/twoPage/industry',
        name: '焦化苯行业动态二级页',
        component: () => import('@/views/cokeBenzene/twoPage/industry')
    },
    {
        path: 'cokeBenzene/industry',
        name: '焦化苯行业动态详情页',
        component: () => import('@/views/cokeBenzene/detail/industry')
    },
    {
        path: 'cokeBenzene/twoPage/price',
        name: '焦化苯价格二级页',
        component: () => import('@/views/cokeBenzene/twoPage/price')
    },
    {
        path: 'cokeBenzene/price',
        name: '焦化苯价格详情页',
        component: () => import('@/views/cokeBenzene/detail/priceIndex')
    },
    {
        path: 'cokeBenzene/twoPage/report',
        name: '焦化苯研究报告二级页',
        component: () => import('@/views/cokeBenzene/twoPage/report')
    },
    {
        path: 'cokeBenzene/twoPage/yield',
        name: '焦化苯产量二级页',
        component: () => import('@/views/cokeBenzene/twoPage/yield')
    },
    {
        path: 'cokeBenzene/yield',
        name: '焦化苯产量详情页',
        component: () => import('@/views/cokeBenzene/detail/yield')
    },
    {
        path: 'cokeBenzene/twoPage/stock',
        name: '焦化苯库存二级页',
        component: () => import('@/views/cokeBenzene/twoPage/stock')
    },
    {
        path: 'cokeBenzene/stock',
        name: '焦化苯库存详情页',
        component: () => import('@/views/cokeBenzene/detail/stock')
    },
    {
        path: 'cokeBenzene/twoPage/exit',
        name: '焦化苯进出口量二级页',
        component: () => import('@/views/cokeBenzene/twoPage/exit')
    },
    {
        path: 'cokeBenzene/exit',
        name: '焦化苯进出口量详情页',
        component: () => import('@/views/cokeBenzene/detail/exit')
    },
    {
        path: 'cokeBenzene/twoPage/productPrice',
        name: '焦化苯相关产品价格二级页',
        component: () => import('@/views/cokeBenzene/twoPage/productPrice')
    },
    {
        path: 'cokeBenzene/productPrice',
        name: '焦化苯相关产品价格详情页',
        component: () => import('@/views/cokeBenzene/detail/productPrice')
    },
    {
        path: 'cokeBenzene/productPriceContent',
        name: '焦化苯相关产品价格详情页苯乙烯',
        component: () => import('@/views/cokeBenzene/detail/productPriceContent')
    },
    {
        path: 'cokeBenzene/backPrice',
        name: '焦化苯后两个价格详情页',
        component: () => import('@/views/cokeBenzene/detail/backPrice')
    },
    {
        path: 'cokeBenzene/twoPage/device',
        name: '焦化苯装置动态二级页',
        component: () => import('@/views/cokeBenzene/twoPage/device')
    },
    {
        path: 'cokeBenzene/device',
        name: '焦化苯装置动态详情页',
        component: () => import('@/views/cokeBenzene/detail/device')
    },
    {
        path: 'cokeBenzene/twoPage/standard',
        name: '焦化苯行业标准二级页',
        component: () => import('@/views/cokeBenzene/twoPage/standard')
    },
    {
        path: 'cokeBenzene/relatedProducts',
        name: '焦化苯相关产品价格外部链接',
        component: () => import('@/views/cokeBenzene/detail/relatedProducts.vue')
    },
    {
        path: 'cokeBenzene/map',
        name: '焦化苯地图',
        component: () => import('@/views/cokeBenzene/detail/map.vue')
    },
]
export default routes
